<template>
    <div class="marketTextholder" v-if="marketName !== 'Match Winner'">
        <div :class="{'disableText':(marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0),'marketName':(true)}" >{{marketDetail.marketDetailName}}</div>
        <div v-if="marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0" :class="{'lock':(true)}"><i class="material-icons lock-icon">lock</i></div>
        <div v-else :class="{'disableText':(marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0),'odd':(true)}">{{marketDetail.marketDetailOdd}}</div>
    </div>
    <div class="mWMarketTextholder" v-else-if="marketName === 'Match Winner'">
        <div :class="{'disableText':(marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0),'mWmarketName':(true)}">{{getMarketName(marketDetail.marketDetailNumber)}}</div>
        <div v-if="marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0" :class="{'mWlock':(true)}"><i class="material-icons lock-icon">lock</i></div>
        <div v-else :class="{'disableText':(marketDetail.marketDetailStatus !== 1 || marketStatusId !== 1 || marketDetail.marketDetailOdd === 0),'mWodd':(true)}">{{marketDetail.marketDetailOdd}}</div>
    </div>
</template>

<script>
    export default {
        name: 'Market',
        props: {
            marketName: String,
            marketDetail: Object,
            marketStatusId: Number
        },
        methods: {
            getMarketName(detailNumber){
                switch(detailNumber) {
                    case 1:
                        return 'Home';
                    case 2:
                        return 'Draw';
                    case 3:
                        return 'Away';
                    default:
                        return this.marketDetail.marketDetailName;
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .marketTextholder {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-overflow: ellipsis;
        overflow: visible;
        text-transform: none !important;
        padding: 8px;
        width: 100%;
        height: 36px !important;
        border-radius: 4px; 
    }

    .marketName {
        font: normal normal normal 12px/18px Poppins;
        color: #8064E7;
        text-transform: uppercase;
        opacity: 1;
    }

    .lock {
        font-size: 16px !important;
        color: #b0b0b0 !important;
        margin-left: 8px !important;
    }

    .odd {
        font-size: 14px !important;
        font-weight: bold !important;
        margin-left: 16px !important;
    }

    .disableText {
        color: #b0b0b0;
    }

    .lock-icon {
        font-size: 16px;
    }


    .v-btn--active {
        background-color: white !important;
        
    }
    .disableText {
        text-decoration: line-through !important;
    }

    .disableText.marketName {
        display: block !important;
    }

    .marketTextholder {
        width: 90%;
        display: flex;
        text-overflow: ellipsis;
        overflow: visible;
        height: 36px !important;
    }

    .mWMarketTextholder {
        width: 100%;
        display: flex !important;
        flex-direction: column;
        text-overflow: ellipsis;
        overflow: visible;
        margin-top: 10px;
        margin-bottom: 5px;
        align-items: center;
        color: #8064E7;
        text-transform: none !important;
    }

    .v-btn.v-btn--flat.theme--dark.info--text .marketTextholder {
        border-bottom: 0px solid #000 !important;
    }

    .mWmarketName {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100% - 43px);
        font: normal normal normal 14px/21px Poppins;
        white-space: nowrap;
        color: #B2B3BD;
    }

    .odd {
        color: #8064E6;
        display: inline-block;
        width: 43px;
        position: relative;
    }

    .mWodd
    {
        display: inline-block;
        width: 43px;
        position: relative;
        margin-bottom: 5px;
        font: normal normal bold 14px/22px Poppins;
        font-weight: bold;
        opacity: 1;
    }

    @media (max-width: 960px) {

        .mWodd {
            display: inline-block;
            width: 43px;
            position: relative;
            margin-bottom: 5px;
            font-size: 10px;
        }

        .mWmarketName {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            font-size: 10px;
            white-space: nowrap;
        }



        .lock-icon {
            font-size: 15px;
        }

        .mWMarketTextholder {
            width: 80% !important;
        }
    }

    .lock {
        color: #000;
        display: inline-block;
        position: relative;
    }

    .mWlock {
        color: #8064E7;
        display: inline-block;
        position: relative;
    }


    .lock .material-icons {
        font-size: 15px;
    }
</style>
